import { FormBase } from 'core/components';
import _ from 'lodash';

export default class ProductEditForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	setup() {
		return {
			fields: [
				{
					name: 'seller',
					label: 'PRODUCTVIEW.SELLER',
				},
			],
		};
	}

	options() {
		return {
			validateOnChange: true,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/forms/ProductImportForm.js